<template>
  <div class="step6">
    <div ref="checked" class="checked">
    </div>
    <Tips class="mt-2">
      <template v-slot:content>
        <div>
          注销账号申请提交成功，我们将在
          <span style="font-weight: bolder; color: #ff6600">{{ date }}</span>
          日完成注销。请注意，该账号注销有15日的冷静期（账号锁定期）。除法律法规规定和账号注销协议约定的情形外，我们将在冷静期届满后完成注销，删除或匿名化您的个人信息。
          <a style="font-weight: 700;display:block;text-decoration:none;" class="mt-2 mb-2">在冷静期内，请不要再次登录和使用该账号，以确保注销流程的顺利进行；如您在冷静期内再次通过该账号登录和使用心动游戏服务，则视为您主动撤销注销账号申请</a>
          最后非常感谢你这段时间对心动游戏的喜爱，若有其他问题请联系客服反馈。
          <br/>
        </div>
      </template>
    </Tips>
    <!-- <Button @click="goToNextStep" class="next-step" text="下一步" /> -->
  </div>
</template>

<script>
// import Button from '../../components/button'
import Checked from '../../assets/check.json'
import lottie from 'lottie-web'
import Tips from '../../components/tips'
export default {
  props: {
    nextStep: {
      type: Function,
      default: () => {}
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeHolder: '请输入你的心动 ID',
      value: '',
      isShowDialog: false,
      queryIDContentStyle: {
        width: '89%',
        height: '90%',
        border: '1px solid #E6E6E6',
        'border-radius': '5px'
      },
      queryIDContentTitle: {
        height: '58px',
        'border-bottom': '1px solid #8a8a8a1f',
        'text-align': 'center',
        'font-family': 'PingFang SC',
        'font-style': 'normal',
        'font-weight': '500',
        'font-size': '16px',
        'line-height': '58px',
        /* identical to box height, or 162% */
        'letter-spacing': '4.93506e-09px',
        color: '#333333'
      },
      date: ''
    }
  },
  components: {
    Tips
  },
  mounted () {
    if (!window.logOut) {
      this.$router.push({
        name: 'Home',
        hash: '#step1',
        params: { index: this.stepsIndex + 1 }
      })
    }
    lottie.loadAnimation({
      container: this.$refs.checked, // the dom element that will contain the animation
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: Checked // the path to the animation json
    })
    window.user_id = null
    window.cancelDetails = null
    window.cancellationAgreement = null
    window.userData = null
    window.logOut = null
    this.date = this.getDateTime()
  },
  methods: {
    toggleDialog () {
      this.isShowDialog = !this.isShowDialog
    },
    goToNextStep () {
      this.$emit('nextStep')
    },
    onInputChange (e) {
      // console.log(e)
    },
    getDateTime () {
      const time = new Date().getTime() + 86400000 * 15
      const date = new Date(time)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    }
  }
}
</script>

<style lang="less" scoped>
.step6 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .checked{
      width: 160px;
      height: 160px;
      align-self: center;
      margin-top: 16px;
  }
  .warning {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 25px;
    text-align: justify;
    margin-top: 16px;

    /* 正文 */

    color: #5c5c5c;
  }
  .next-step {
    margin-top: 20px;
    /* VI */
    background: #ff6600;
    border-radius: 5px;
    color: #fff;
    font-size: 14px;
    padding-top: 9px;
    padding-bottom: 9px;
    border: 0;
    height: 42px;
  }
}
</style>
